var m = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var o = (n, e, t) => e in n ? m(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, s = (n, e) => {
  for (var t in e || (e = {}))
    v.call(e, t) && o(n, t, e[t]);
  if (i)
    for (var t of i(e))
      u.call(e, t) && o(n, t, e[t]);
  return n;
};
import { DefaultEnvironment as a } from "./defaults.es.js";
import { getJSONTagContent as c } from "./meta-tag-helper.es.js";
let r = a;
const [g, f] = c("sq:environment");
g === null ? r = s({ service_name: a.service_name }, f) : console.warn("Invalid sq:environment meta tag detected! Using default environment configuration");
Object.defineProperty(r, "website_host", {
  get() {
    return this.website_host_override ? this.website_host_override : this.env === "production" ? "https://squareup.com" : this.env === "staging" ? "https://squareupstaging.com" : "";
  }
});
const d = () => r.env;
export {
  r as Environment,
  d as getEnv
};
